import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AiTrainerAuthProvider } from '@/contexts/AiTrainerAuthContext';
import RequireTrainer from '@/components/AiTrainer/RequireTrainer';
import LoginPage from '@/components/AiTrainer/LoginPage';
import RegisterPage from '@/components/AiTrainer/RegisterPage';
import PendingPage from '@/components/AiTrainer/PendingPage';
import ExamCorpusPage from '@/Pages/ExamCorpusPage';

/**
 * Standalone router for the trainer portal.
 *
 * Three public routes (login / register / pending) and one gated route
 * (the upload library). Anything else 404s back to /library so the
 * URL is predictable.
 */
export default function App() {
  return (
    <BrowserRouter>
      <AiTrainerAuthProvider>
        <Routes>
          {/* Public auth surface */}
          <Route path="/login"    element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/pending"  element={<PendingPage />} />

          {/* Trainer-only library */}
          <Route
            path="/library"
            element={
              <RequireTrainer>
                <ExamCorpusPage />
              </RequireTrainer>
            }
          />

          {/* Defaults */}
          <Route path="/" element={<Navigate to="/library" replace />} />
          <Route path="*" element={<Navigate to="/library" replace />} />
        </Routes>
      </AiTrainerAuthProvider>
    </BrowserRouter>
  );
}
